import { render, staticRenderFns } from "./DownloadResourseItem.vue?vue&type=template&id=05ccef84&scoped=true"
import script from "./DownloadResourseItem.vue?vue&type=script&lang=js"
export * from "./DownloadResourseItem.vue?vue&type=script&lang=js"
import style0 from "./DownloadResourseItem.vue?vue&type=style&index=0&id=05ccef84&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ccef84",
  null
  
)

export default component.exports